import React from 'react';
import { Box } from '@mui/material';
import { useFieldHelper, TextField } from 'framework/ui/field';
import DownloadIcon from '@mui/icons-material/Download';
import useLeadReportService from 'domain/sales/report/useLeadReportService';
import { SmallLoader } from 'framework/ui/mui-builder';

const LEAD_REPORT = 'Lead Report';

const LeadReportLinkField = (props: any) => {
  const { getValue: getId } = useFieldHelper({ source: 'id' });
  const { downloadReport } = useLeadReportService();

  const [loading, setLoading] = React.useState(false);

  let icon = null;

  if (!loading) {
    icon = (
      <DownloadIcon
        onClick={() => {
          setLoading(true);
          downloadReport(getId()).then(() => setLoading(false));
        }}
        color="primary"
        sx={{
          'font-size': '15px',
          cursor: 'pointer',
        }}
      />
    );
  } else {
    icon = <SmallLoader />;
  }

  const value = (
    <Box display="flex" alignItems="flex-end" gap={1}>
      {LEAD_REPORT}
      {icon}
    </Box>
  );

  return <TextField value={value} />;
};

export default LeadReportLinkField;
